// extracted by mini-css-extract-plugin
export default {"container":"VectorDBSettings_container__yV5vI","widgetWrapper":"VectorDBSettings_widgetWrapper__6xu7V"};